export default "__VITE_ASSET__CghKls77__"